<template>
  <fragment>
    <slot />
    <ValidationObserver
      ref="form"
      v-slot="{ handleSubmit }"
      class="relative"
    >
      <form
        class="relative"
        @submit.prevent="handleSubmit(checkCreator)"
      >
        <ValidationProvider
          v-slot="{ errors }"
          vid="tag"
          name="correo"
          :rules="rules"
        >
          <div :class="`flex font-bold text-md h-10 px-2 text-purple-500 border-2 border-${!errors.length ? 'purple-200' : 'red-500' } focus:border-${!errors.length ? 'purple-500' : 'red-500' } rounded-sm `">
            <input
              ref="tagInput"
              v-model="tagToUse"
              class="w-full"
              :disabled="disabled"
              type="text"
              :placeholder="placeholder"
              @keyup="doSearch"
              @focus="doSearch"
              @blur="stopSearch"
            >
          </div>
        </validationprovider>
        <div
          v-if="searching"
          class="absolute w-full bg-gray-500 p-4 rounded-sm z-50"
        >
          <div
            v-if="results.length"
            class="flex flex-wrap"
          >
            <a
              v-for="(result, index) in results"
              :key="result[0]"
              :class="`inline-block p-2 text-lg mr-2 mb-2 rounded-sm ${index === 0 ? 'text-white bg-purple-500' : 'bg-purple-100 text-purple-500'}`"
              @click="selectTag(result[0])"
            >
              #{{ result[1] }}
            </a>
          </div>
          <div
            v-else
            class="text-white"
          >
            No se encontraron resultados {{ `${creator ? ', presiona enter para crear.' : ''}` }}
          </div>
        </div>
      </form>
    </ValidationObserver>
    <transition-group
      name="list"
      class="flex flex-wrap"
      tag="div"
    >
      <div
        v-for="(label, tagID) in currentTags"
        :key="`${label}_${tagID}`"
        class="flex items-center p-2 bg-purple-200 rounded-md text-purple-500 font-bold mr-2 mt-2 transition-all duration-500"
        @mouseenter="hoverTag=tagID"
        @mouseleave="hoverTag=null"
      >
        <div>
          #{{ label }}
        </div>
        <eva-icon
          name="close-outline"
          :fill="`${hoverTag===tagID? '#FF7570' : '#8B80F9'}`"
          animation="pulse"
          width="24"
          height="24"
          class="cursor-pointer align-bottom"
          @click="removeTag(tagID)"
        />
      </div>
    </transition-group>
  </fragment>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    currentTags: { type: Object, default: () => {} },
    selectableTags: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    creator: { type: Boolean, default: false },
    rules: { type: [String, Object], default: () => {} },
    autofocus: { type: Boolean, default: false },
    placeholder: { type: String, default: '[Enter para agregar]' },
  },
  data () {
    return {
      tagToUse: '',
      hoverTag: null,
      searching: false,
      results: [],
    }
  },
  computed: {
    unselectedSelectableTags () {
      const unselected = {}
      for (const tag of Object.keys(this.selectableTags)) {
        if (!this.currentTags[tag]) {
          unselected[tag] = this.selectableTags[tag]
        }
      }
      return unselected
    },
  },
  watch: {
    searching (val) {
      this.$emit('state:search', val)
    },
    success (val) {
      if (typeof val === 'boolean' && this.tagToUse !== '') {
        this.tagToUse = ''
        this.$nextTick(() => {
          this.$refs.tagInput.focus()
        })
      }
    },
  },
  mounted () {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.$refs.tagInput.focus()
      })
    }
  },
  methods: {
    stopSearch () {
      setTimeout(() => {
        this.searching = false
      }, 400)
    },
    doSearch (e) {
      if (typeof this.unselectedSelectableTags !== 'undefined' && Object.keys(this.unselectedSelectableTags).length) {
        if ((e.keyCode === 13 && this.creator)) {
          this.searching = false
          this.results = []
        } else {
          if (e.keyCode !== 13) {
            this.searching = true
            this.results = Object.entries(this.unselectedSelectableTags).filter(tag => {
              return tag[1].toLowerCase().includes(this.tagToUse.toLowerCase())
            }).sort((a, b) => {
              const aStartsWith = Number(a[1].toLowerCase().startsWith(this.tagToUse.toLowerCase()))
              const bStartWith = Number(b[1].toLowerCase().startsWith(this.tagToUse.toLowerCase()))
              if (aStartsWith < bStartWith) {
                return 1
              }
              if (aStartsWith > bStartWith) {
                return -1
              }
              return 0
            })
          }
        }
      }
    },
    selectTag (tagID) {
      this.tagToUse = ''
      this.$emit('tag:add', tagID)
      this.resetState()
    },
    checkCreator () {
      if (this.creator) {
        this.createTag()
      } else {
        if (this.results.length && this.tagToUse !== '') {
          return this.selectTag(this.results[0][0])
        }
      }
    },
    createTag () {
      if (this.tagToUse !== '') {
        this.$emit('tag:add', this.tagToUse)
        this.resetState()
      }
    },
    removeTag (tag) {
      this.$emit('tag:remove', tag)
    },
    resetState () {
      this.$refs.form.reset()
      this.searching = false
    },
  },
}
</script>
<style lang="scss" scoped>
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.list-enter-active {
  position: relative;
}
.list-leave-active {
  position: absolute;
}
</style>
